import {OrderStatus} from '@domain/model/Order';

export enum Accordions {
  USER_INFO = 'USER_INFO',
  BALANCE = 'BALANCE',
  CURRENT_LOOKIERO = 'CURRENT_LOOKIERO',
  SHIPPING_ADDRESS = 'SHIPPING_ADDRESS',
  PAYMENT = 'PAYMENT',
}

export const ACCORDIONS_POSITION = [
  Accordions.USER_INFO,
  Accordions.BALANCE,
  Accordions.CURRENT_LOOKIERO,
  Accordions.SHIPPING_ADDRESS,
  Accordions.PAYMENT,
];

export const ACCORDION_HEIGHT = 78;
export const ACCORDION_GAP = 64;

export const DATE_FORMAT = {month: 'long', day: '2-digit', weekday: 'long'};

export const TEXT = {
  BALANCE: {id: 'account.menu.balance'},
  BALANCE_DETAIL: {id: 'account.menu.balance_detail'},

  CARD_ENDING: {id: 'account.menu.payment_detail'},

  CURRENT_LOOKIERO: {id: 'account.menu.currentLK'},
  CURRENT_LOOKIERO_READY: {id: 'account.menu.currentLK_detail_creating'},
  CURRENT_LOOKIERO_NO_ORDER: {id: 'account.menu.currentLK_detail_noOrder'},

  FREQUENCY: {id: 'account.menu.frequency'},

  LOGOUT: {id: 'account.menu.logout_link'},

  NOTIFICATION_ERROR: {id: 'account.info.toast_error'},

  ORDER: {id: 'account.menu.order_paragraph'},
  ORDER_CTA: {id: 'account.menu.order_cta'},
  ORDER_NONE: {id: 'account.menu.detail_noOrder'},

  PAYMENT: {id: 'account.menu.payment'},
  PAYPAL: {id: 'payment.method.paypal.title'},

  SHIPPING_ADDRESS: {id: 'account.menu.shipping'},

  TITLE: {id: 'account.menu.title'},
  TITLE_NO_ORDERS: {id: 'account.menu.title_noOrder'},
  TOAST_GENERIC_ERROR: {id: 'toast.generic.error'},

  USER_INFO: {id: 'account.menu.userInfo'},

  PLAN_TITLE: {id: 'account_yourPlan.plan.title'},
  KLARNA: {id: 'payment.method.klarna'},
};

// TODO repeated definition in some other place. Searh for it.
export const ORDER_IN_PROGRESS_STATUSES = [
  OrderStatus.PEDIDO_REALIZADO,
  OrderStatus.EN_MARCHA,
  OrderStatus.BORRADOR,
  OrderStatus.EN_PREPARACION,
  OrderStatus.ENVIADO,
];

export const ORDER_DRAFT_STATUSES = [OrderStatus.PEDIDO_REALIZADO, OrderStatus.BORRADOR, OrderStatus.EN_MARCHA];

export const ORDER_RETURNING_STATUS = [OrderStatus.LIQUIDADO, OrderStatus.RETORNADO];

export const IDS = {
  OPEN_MY_LK: 'AccountBoxMgmt',
  OPEN_FREQUENCY: 'AccountSubsMgmt',
};
